import { FC, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useAppSelector } from 'src/Hooks/redux'
import { getUserId } from 'src/Redux/auth-process/userSlice/selectors'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'
import { toggleActivatedEvent } from 'src/Helpers/TagManager'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { getAllCampaignsCount, useMetadataQuery } from 'src/Redux/metadataApi'

import { SelectStrategy } from './SelectStrategy'

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    padding: 0;
  }
`

export const Strategy: FC = () => {
  const navigate = useNavigate()
  const { data } = useMetadataQuery(null)
  const amountOfCampaigns = getAllCampaignsCount(data)
  const userId = useAppSelector(getUserId)
  const campaignNumber = amountOfCampaigns + 1

  useEffect(() => {
    toggleActivatedEvent({
      platformName: CampaignPlatformTypeEnum.META,
      campaignType: CampaignTypeEnum.BASIC,
      campaignNumber,
      userId,
    })
  }, [campaignNumber, userId])

  const handleSelectStrategy = (strategy: AdCampaignStrategyEnum): void => {
    navigate(`${ArtistRoutesEnum.CreateAds}/${strategy}`)
  }
  return (
    <Container>
      <SelectStrategy onSelectStrategy={handleSelectStrategy} />
    </Container>
  )
}
